import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the TimediffnowPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'timediffnow',
})
export class TimediffnowPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: number, ...args) {
    let h = 60 * 60 * 1000;
    let d = 24 * h;

    let diff_string = '';
    //如果是 秒 为单位就变为毫秒
    if(String(value).length == 10 || String(value).length==11) value*=1000;

    value = new Date().getTime() - value;

    if (value < h) {
      diff_string = '不到1小时';
    } else if (value >= h && value <= d) {
      diff_string = Math.floor(value / h) + '小时';
    } else if (value > d && value <= 2 * d) {
      diff_string =
        Math.floor(value / d) + '天' + Math.ceil((value - d) / h) + '小时';
    } else {
      diff_string = Math.floor(value / d) + '天';
    }

    return diff_string;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/timediffnow/timediffnow.ts